import AccessManager2 from "./AccessManager2"

export default _ => {
    const hasAcces2 = (ressource) => AccessManager2(ressource);

    return hasAcces2;
}